import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import logo from '../../imgs/logo_komity.png';

const API = (config.api_url || '').replace(/\/$/, '');

function Paso1Solicitar({ onEnviado }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return setError('Ingresa tu correo electrónico.');
        setError('');
        setLoading(true);
        try {
            const res = await axios.post(`${API}/api/auth/solicitar-recuperacion`, { email: email.trim().toLowerCase() });
            const d = res.data;
            if (d.status === 'success') {
                onEnviado({ email, devMode: d.dev_mode, recoveryUrl: d.recovery_url });
            } else {
                setError(d.message || 'No se pudo procesar la solicitud.');
            }
        } catch {
            setError('Error de conexión con el servidor.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>🔑</div>
                <h2 style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1a1a2e', margin: 0 }}>¿Olvidaste tu contraseña?</h2>
                <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '6px' }}>Ingresa tu correo y te enviaremos instrucciones.</p>
            </div>
            <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Correo electrónico"
                style={{ width: '100%', padding: '14px 16px', borderRadius: '12px', border: '2px solid #e5e7eb', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
                autoFocus
            />
            {error && <div style={{ color: '#DC2626', fontSize: '0.82rem', fontWeight: 600 }}>{error}</div>}
            <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', padding: '15px', borderRadius: '50px', border: 'none', background: 'linear-gradient(135deg, #7A27F5, #FC1958)', color: '#fff', fontWeight: 700, fontSize: '1rem', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}
            >
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
            </button>
            <div style={{ textAlign: 'center' }}>
                <a href="/adminlogin" style={{ color: '#94a3b8', fontSize: '0.85rem', textDecoration: 'none' }}>← Volver al login</a>
            </div>
        </form>
    );
}

function Paso2Confirmar({ tokenInicial }) {
    const [token] = useState(tokenInicial || '');
    const [password, setPassword] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [exito, setExito] = useState(false);
    const [tokenValido, setTokenValido] = useState(null);

    useEffect(() => {
        const verificar = async () => {
            try {
                const res = await axios.post(`${API}/api/auth/validar-token-recuperacion`, { token });
                setTokenValido(res.data.valido === true);
            } catch {
                setTokenValido(false);
            }
        };
        if (token) verificar();
        else setTokenValido(false);
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password.length < 6) return setError('La contraseña debe tener al menos 6 caracteres.');
        if (password !== confirmar) return setError('Las contraseñas no coinciden.');
        setError('');
        setLoading(true);
        try {
            const res = await axios.post(`${API}/api/auth/confirmar-recuperacion`, { token, password });
            if (res.data.status === 'success') {
                setExito(true);
            } else {
                setError(res.data.message || 'No se pudo actualizar la contraseña.');
            }
        } catch {
            setError('Error de conexión con el servidor.');
        } finally {
            setLoading(false);
        }
    };

    if (tokenValido === null) {
        return <div style={{ textAlign: 'center', padding: '40px 0' }}><div style={{ width: '32px', height: '32px', border: '3px solid #e2e8f0', borderTopColor: '#7A27F5', borderRadius: '50%', animation: 'spin 0.6s linear infinite', margin: '0 auto' }} /><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>;
    }

    if (!tokenValido) {
        return (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>⚠️</div>
                <h3 style={{ fontWeight: 700, color: '#1a1a2e' }}>Link inválido o expirado</h3>
                <p style={{ color: '#94a3b8', fontSize: '0.9rem' }}>El link de recuperación expiró (válido 30 min). Solicita uno nuevo.</p>
                <a href="/usuario/recupera/" style={{ display: 'inline-block', marginTop: '16px', padding: '12px 24px', background: 'linear-gradient(135deg, #7A27F5, #FC1958)', color: '#fff', borderRadius: '50px', textDecoration: 'none', fontWeight: 700 }}>
                    Solicitar nuevo link
                </a>
            </div>
        );
    }

    if (exito) {
        return (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>✅</div>
                <h3 style={{ fontWeight: 700, color: '#1a1a2e' }}>¡Contraseña actualizada!</h3>
                <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '20px' }}>Ya puedes iniciar sesión con tu nueva contraseña.</p>
                <a href="/adminlogin" style={{ display: 'inline-block', padding: '12px 28px', background: 'linear-gradient(135deg, #7A27F5, #FC1958)', color: '#fff', borderRadius: '50px', textDecoration: 'none', fontWeight: 700 }}>
                    Ir al login →
                </a>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>🔒</div>
                <h2 style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1a1a2e', margin: 0 }}>Nueva contraseña</h2>
                <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '6px' }}>Elige una contraseña segura de al menos 6 caracteres.</p>
            </div>
            <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Nueva contraseña"
                style={{ width: '100%', padding: '14px 16px', borderRadius: '12px', border: '2px solid #e5e7eb', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
                autoFocus
            />
            <input
                type="password"
                value={confirmar}
                onChange={e => setConfirmar(e.target.value)}
                placeholder="Repite la contraseña"
                style={{ width: '100%', padding: '14px 16px', borderRadius: '12px', border: '2px solid #e5e7eb', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
            />
            {error && <div style={{ color: '#DC2626', fontSize: '0.82rem', fontWeight: 600 }}>{error}</div>}
            <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', padding: '15px', borderRadius: '50px', border: 'none', background: 'linear-gradient(135deg, #7A27F5, #FC1958)', color: '#fff', fontWeight: 700, fontSize: '1rem', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}
            >
                {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
            </button>
        </form>
    );
}

export default function RecuperaPassword() {
    const [estado, setEstado] = useState('solicitar'); // 'solicitar' | 'enviado' | 'confirmar'
    const [datos, setDatos] = useState({});
    const [tokenUrl] = useState(() => new URLSearchParams(window.location.search).get('token') || '');

    useEffect(() => {
        if (tokenUrl) setEstado('confirmar');
    }, [tokenUrl]);

    const handleEnviado = (info) => {
        setDatos(info);
        setEstado('enviado');
    };

    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
            padding: '24px 16px', boxSizing: 'border-box'
        }}>
            <div style={{
                width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.97)',
                borderRadius: '28px', padding: '40px 30px',
                boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
            }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <img src={logo} alt="Komity" style={{ height: '36px' }} />
                </div>

                {estado === 'solicitar' && <Paso1Solicitar onEnviado={handleEnviado} />}

                {estado === 'enviado' && (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>{datos.devMode ? '🔗' : '📧'}</div>
                        <h3 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: '8px' }}>
                            {datos.devMode ? 'Link de recuperación' : '¡Revisa tu correo!'}
                        </h3>
                        {datos.devMode ? (
                            <>
                                <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '16px' }}>
                                    El servidor no tiene email configurado. Usa este link directamente:
                                </p>
                                <div style={{ background: '#f3f4f6', borderRadius: '10px', padding: '12px', marginBottom: '16px', wordBreak: 'break-all', fontSize: '0.8rem', color: '#374151' }}>
                                    {datos.recoveryUrl}
                                </div>
                                <a href={datos.recoveryUrl} style={{ display: 'inline-block', padding: '12px 24px', background: 'linear-gradient(135deg, #7A27F5, #FC1958)', color: '#fff', borderRadius: '50px', textDecoration: 'none', fontWeight: 700 }}>
                                    Restablecer contraseña →
                                </a>
                            </>
                        ) : (
                            <p style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
                                Enviamos las instrucciones a <strong style={{ color: '#374151' }}>{datos.email}</strong>. El link expira en 30 minutos.
                            </p>
                        )}
                        <div style={{ marginTop: '24px' }}>
                            <button onClick={() => setEstado('solicitar')} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '0.85rem', cursor: 'pointer' }}>
                                ← Intentar con otro correo
                            </button>
                        </div>
                    </div>
                )}

                {estado === 'confirmar' && <Paso2Confirmar tokenInicial={tokenUrl} />}
            </div>
        </div>
    );
}
